import { useState } from 'react';
import { ROL_LABEL, type Rol } from '@ep/core';
import { api } from '../lib/api';
import { useActie, useData, useIk, type GebruikerRij } from '../lib/data';
import { Laden, Modal, Veld, VerwijderKnop } from '../ui/ui';

export function Gebruikers() {
  const { data: d } = useData();
  const ik = useIk().data;
  const [form, setForm] = useState<GebruikerRij | 'nieuw' | null>(null);
  if (!d) return <Laden />;
  return (
    <div className="pagina">
      <div className="paneel">
        <div className="sectie-kop">
          <div className="groei">
            <h1>Gebruikers</h1>
            <div className="klein mute">Wie mag de app gebruiken en met welke rol. Engineers met de rol Engineer zien alleen hun eigen taken en kunnen terugmelden.</div>
          </div>
          <button className="knop primair" onClick={() => setForm('nieuw')}>+ Gebruiker</button>
        </div>
        <table className="tabel">
          <thead><tr><th>Naam</th><th>E-mail</th><th>Rol</th><th>Gekoppelde engineer</th><th>Laatst gezien</th></tr></thead>
          <tbody>
            {d.gebruikers.map((u) => (
              <tr key={u.id} className="klik" onClick={() => setForm(u)}>
                <td><b>{u.naam}</b>{u.id === ik?.uid ? <span className="klein mute"> (jij)</span> : null}</td>
                <td>{u.email}</td>
                <td>{ROL_LABEL[u.rol]}</td>
                <td>{d.engineers.find((e) => e.id === u.engineerId)?.naam ?? '–'}</td>
                <td className="klein mute">{u.laatstGezien ? new Date(u.laatstGezien).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' }) : 'nog nooit'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="paneel vlak klein" style={{ marginTop: 12 }}>
          <b>Rollen:</b> Projectmanager – projecten, werkpakketten en taken aanmaken (niet plannen) · Planner – alles rond plannen, verlof en templates · Beheerder – alles, plus beheer, instellingen en gebruikers · Engineer – eigen taken en terugmelden.
        </div>
      </div>
      {form && <GebruikerForm u={form === 'nieuw' ? undefined : form} onSluit={() => setForm(null)} />}
    </div>
  );
}

function GebruikerForm({ u, onSluit }: { u?: GebruikerRij; onSluit: () => void }) {
  const { data: d } = useData();
  const [f, setF] = useState({ naam: u?.naam ?? '', email: u?.email ?? '', rol: (u?.rol ?? 'PLANNER') as Rol, engineerId: u?.engineerId ?? '' });
  const opslaan = useActie(() => (u ? api.put(`/api/gebruikers/${u.id}`, { ...f, engineerId: f.engineerId || null }) : api.post('/api/gebruikers', { ...f, engineerId: f.engineerId || null })), { succes: 'Gebruiker opgeslagen', opNa: onSluit });
  const verwijder = useActie(() => api.del(`/api/gebruikers/${u!.id}`), { succes: 'Gebruiker verwijderd', opNa: onSluit });
  return (
    <Modal titel={u ? 'Gebruiker bewerken' : 'Nieuwe gebruiker'} onSluit={onSluit} voet={<>{u && <VerwijderKnop onBevestig={() => verwijder.mutate()} />}<div className="groei" /><button className="knop" onClick={onSluit}>Annuleren</button><button className="knop primair" onClick={() => opslaan.mutate()}>Opslaan</button></>}>
      <div className="grid2">
        <Veld label="Naam"><input value={f.naam} onChange={(e) => setF({ ...f, naam: e.target.value })} /></Veld>
        <Veld label="E-mailadres (zoals in Microsoft 365)"><input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></Veld>
        <Veld label="Rol">
          <select value={f.rol} onChange={(e) => setF({ ...f, rol: e.target.value as Rol })}>
            {(Object.keys(ROL_LABEL) as Rol[]).map((r) => <option key={r} value={r}>{ROL_LABEL[r]}</option>)}
          </select>
        </Veld>
        <Veld label="Gekoppelde engineer" hint="Voor 'Mijn taken'">
          <select value={f.engineerId} onChange={(e) => setF({ ...f, engineerId: e.target.value })}>
            <option value="">– geen –</option>
            {d?.engineers.map((e) => <option key={e.id} value={e.id}>{e.naam}</option>)}
          </select>
        </Veld>
      </div>
    </Modal>
  );
}
